import Swal from 'sweetalert2';
import API_URL from '../../../config';

const handleLogout = async () => {
  // 1️⃣ Confirmation popup
  const result = await Swal.fire({
    title: '⚠️ Are you sure you want to logout?',
    text: 'You will be logged out from your account and redirected to the login page',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, logout! ✅',
    cancelButtonText: 'No, stay 🛑',
    showClass: { popup: 'animate__animated animate__fadeInDown' },
    hideClass: { popup: 'animate__animated animate__fadeOutUp' },
  });

  if (!result.isConfirmed) return; // Stop if user cancels

  const token = localStorage.getItem('auth_token');

  try {
    // 2️⃣ Optional backend logout
    if (token) {
      await fetch(`${API_URL}/api/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
    }
  } catch (error) {
    console.warn('Server logout failed, continuing...', error);
  } finally {
    // 3️⃣ Remove local tokens
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');

    // 4️⃣ Show "Logged Out" SweetAlert with your GIF
    await Swal.fire({
      title: '🚶‍♂️ Logged Out!',
      html: `<div style="text-align:center;">
                  <img src="https://media4.giphy.com/media/v1.Y2lkPWVjZjA1ZTQ3bzE2MGdjM3oyanZwdHB5Y3Nkdzdpdnd0eHFtYjh1YjBpcTh3MXluNyZlcD12MV9naWZzX3NlYXJjaCZjdD1n/wTzz7aHwJDuHzca871/200.webp" 
           width="100" height="130" />
               <p>See you soon! ✨</p>
             </div>`,
      showConfirmButton: false,
      timer: 2000,
      showClass: { popup: 'animate__animated animate__fadeInDown' },
      hideClass: { popup: 'animate__animated animate__fadeOutUp' },
    });

    // 5️⃣ Redirect to login page after SweetAlert finishes
    window.location.href = '/admin-login';
  }
};

export default handleLogout;
